import { wrapReducer } from "@client/content/lib/helper";
import { type ReduxAction } from "@client/types/ReduxAction";
import { Actions, type SetSelectedItemActionData } from "./actions";
import { type ImageGalleryState } from "./types";

const reducer = (state: ImageGalleryState, action: ReduxAction<any>): ImageGalleryState => {
  switch (action.type) {
    case Actions.SetSelectedItem: {
      const { itemId } = action.data as SetSelectedItemActionData;
      return {
        ...state,
        selectedItemId: itemId
      };
    }
    default:
      return state;
  }
};

export const defaultState: ImageGalleryState = {
  id: "",
  selectedItemId: null,
  status: "Ready"
};
export const previewState: ImageGalleryState = defaultState;
export default wrapReducer({ defaultState, reducer, previewState });
